module.exports = __webpack_public_path__ + "static/media/record.616df15d.png";